module.exports = __webpack_public_path__ + "img/Tessellate48.11e0c2fc.jpg";